import { ReactNode } from 'react'

import { BoxSizeStep } from 'routes/Signup/Steps/BoxSize/BoxSizeStep'
import { BoxSizeWithRadioStep } from 'routes/Signup/Steps/BoxSizeWithRadio/BoxSizeWithRadioStep'
import { DeliveryStep } from 'routes/Signup/Steps/Delivery/DeliveryStep'
import { PostcodeStep } from 'routes/Signup/Steps/Postcode/PostcodeStep'
import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

/**
 * SignupSteps to StepComponent relation.
 */
export const AVAILABLE_STEP_COMPONENTS: {
  [step in SignupSteps]: ReactNode
} = {
  [SignupSteps.BOX_SIZE]: BoxSizeStep,
  [SignupSteps.BOX_SIZE_WITH_RADIO]: BoxSizeWithRadioStep,
  [SignupSteps.POSTCODE]: PostcodeStep,
  [SignupSteps.DELIVERY]: DeliveryStep,
}
